module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@3x-a6175407f1fc89278eba7b053accdb00.png";